import React from "react";
import { useNavigate } from "react-router-dom";
import AdminShell from "@/pages/admin/AdminShell";
import { ExecOverview } from "@/pages/admin/AdminDashboard";

/** /dashboard — Executive overview (NBA widget + KPIs + funnel). */
export default function DashboardPage() {
  const navigate = useNavigate();
  // ExecOverview expects onNavigate(tabKey). We map tab keys to routes.
  const onNavigate = (key) => {
    const map = {
      alerts: "/alerts", leads: "/leads", villas: "/villas",
      dataroom: "/documents", documents: "/documents",
      activity: "/activity", users: "/users",
      payments: "/payments", tasks: "/tasks",
      progress: "/villas", integrations: "/settings",
    };
    navigate(map[key] || "/dashboard");
  };
  return (
    <AdminShell>
      <ExecOverview onNavigate={onNavigate} />
    </AdminShell>
  );
}
